var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9250_69974)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.97949,
    width: 22.144,
    height: 22.0409,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8216 15.6261C20.3193 15.0552 19.2033 14.7698 17.6966 14.7698C16.8037 14.7698 15.855 14.8839 14.739 15.0552C13.5573 13.9228 12.5756 12.5901 11.8372 11.1159C12.3952 9.40317 12.7858 7.74752 12.7858 6.49151C12.7858 5.52096 12.451 3.97949 11.1117 3.97949C10.7211 3.97949 10.3863 4.20786 10.1631 4.55041C9.60504 5.57805 9.82826 7.8617 10.8885 10.2595C10.114 12.5508 9.18161 14.783 8.09835 16.9392C5.14076 18.1952 3.18763 19.5654 3.02022 20.6502C2.90861 21.164 3.24343 22.0204 4.41531 22.0204C6.14522 22.0204 8.04254 19.4512 9.49343 16.825C11.1683 16.2358 12.8846 15.7778 14.6274 15.4549C16.7479 17.3389 18.5894 17.6243 19.4823 17.6243C21.268 17.6243 21.4354 16.3112 20.8216 15.6261ZM10.4421 4.72168C10.8885 4.03658 11.893 4.26495 11.893 5.63514C11.893 6.5486 11.614 8.03298 11.0559 9.74572C10.0515 7.34788 10.0515 5.46387 10.4421 4.72168ZM3.35504 20.7073C3.52245 19.7938 5.19656 18.5378 7.81933 17.453C6.36843 19.9651 4.91754 21.5636 4.02468 21.5636C3.46665 21.5636 3.29924 21.0498 3.35504 20.7073ZM14.3483 15.1123C12.776 15.4121 11.2277 15.8319 9.71665 16.3683C10.5426 14.8431 11.2157 13.2364 11.7256 11.5726C12.459 12.8551 13.3395 14.0434 14.3483 15.1123ZM15.0738 15.3407C16.8595 15.0552 18.3662 15.1123 19.0358 15.2265C20.6541 15.569 20.0961 17.5672 18.3104 17.1105C17.0269 16.825 15.9666 16.0829 15.0738 15.3407Z",
    fill: "#C80A0A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9250_69974",
    x: 0,
    y: 0.979492,
    width: 24.144,
    height: 24.0408,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9250_69974"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9250_69974",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf_icon.d2e0cf391044323869dc7a34ebd6b57a.svg";
export { ForwardRef as ReactComponent };